import { render, staticRenderFns } from "./FirstPay.vue?vue&type=template&id=0fa44156&scoped=true&"
import script from "./FirstPay.vue?vue&type=script&lang=js&"
export * from "./FirstPay.vue?vue&type=script&lang=js&"
import style0 from "./FirstPay.vue?vue&type=style&index=0&id=0fa44156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa44156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa44156')) {
      api.createRecord('0fa44156', component.options)
    } else {
      api.reload('0fa44156', component.options)
    }
    module.hot.accept("./FirstPay.vue?vue&type=template&id=0fa44156&scoped=true&", function () {
      api.rerender('0fa44156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/FirstPay.vue"
export default component.exports